import { render, staticRenderFns } from "./AspectPrioriteitMatrix.vue?vue&type=template&id=0fc1ca2d"
import script from "./AspectPrioriteitMatrix.vue?vue&type=script&lang=js"
export * from "./AspectPrioriteitMatrix.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports